import $clamp from 'clamp-js';

export default (container, selector, clampAmount = 15) => {
  const clampContainer = container
    ? container.querySelectorAll(selector)
    : document.querySelectorAll(selector);

  if (clampContainer) {
    clampContainer.forEach((module) => {
      $clamp(module, {
        clamp: clampAmount,
      });
    });
  }
};
